import Links from "../components/Links";
import Repertoire from "../components/Repertoire";

const Resources = () => {
    return (
        <div id="resource-container">
            <h1>Student Resources</h1>
            <Links />
            <Repertoire />
        </div>
    )
}

export default Resources;